<template>
  <div id="app"><Navbar /><router-view /></div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default { name: 'App', components: { Navbar } }
</script>

<style lang="scss">
#app {
  overflow-x: hidden;
  padding-top: 56px;
}
</style>
